import { render, staticRenderFns } from "./VisitsPayWaits.vue?vue&type=template&id=6efc327c"
import script from "./VisitsPayWaits.vue?vue&type=script&lang=js"
export * from "./VisitsPayWaits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports